import { useTranslation } from 'react-i18next'

import { useInitData, useNotification } from '../../../../hooks'
import { NewsboardPostFormModal } from '../../../Newsboard'
import { getPostCreationSuccessNotification } from '../../Post.utils'

export function useCreatePost({ setModal, onClose, onReload }) {
  const { t } = useTranslation()

  const { handleAddSuccessNotification } = useNotification()

  const { availableSections } = useInitData()

  function handleSuccess({ title, uuid }) {
    onClose()

    handleAddSuccessNotification(
      getPostCreationSuccessNotification({ availableSections, t, title, uuid })
    )

    onReload?.()
  }

  function handleOpenCreation(modalProps) {
    setModal(
      <NewsboardPostFormModal
        {...modalProps}
        onClose={onClose}
        onSuccess={handleSuccess}
      />
    )
  }

  return { handleOpenCreation }
}
